import { UnderlineReadOnlyPlugin } from '../../../slatePlugins/marks/underline';
import { DEFAULT_HIGHLIGHT_COLORS_LIST } from '../../DolEditor/elements/highlight/defaults';
import { IconReadOnlyPlugin } from '../../DolEditor/elements/icons/IconPlugin';
import { RoundedElementReadOnlyPlugin } from '../../DolEditor/elements/rounded/plugin';
import { TextColorReadOnlyPlugin } from '../../DolEditor/marks/text-color/TextColorPlugin';
import { UnderlineColorReadOnlyPlugin } from '../../DolEditor/marks/underline-color/UnderlineColorPlugin';
import { TextTransformPlugin } from '../plugins/TextTransform/TextTransformPlugin';
import { AlignReadOnlyPlugin } from '../../../slatePlugins/elements/align/AlignReadOnlyPlugin';
import { BoldReadOnlyPlugin } from '../../../slatePlugins/marks/bold/BoldReadOnlyPlugin';
import { ItalicReadOnlyPlugin } from '../../../slatePlugins/marks/italic/ItalicReadOnlyPlugin';
import { HighlightElementReadOnlyPlugin } from '../../DolEditor/elements/highlight/HighlightReadOnlyPlugin';
import { QuestionStyleReadOnlyPlugin } from '../plugins/QuestionStyle/QuestionStyleReadOnlyPlugin';
import { HyperLinkElementReadOnlyPlugin } from '../../DolEditor/elements/hyper-link/HyperLinkElementReadOnlyPlugin';
import { StrikethroughReadOnlyPlugin } from '../../../slatePlugins/marks/strikethrough/StrikethroughReadOnlyPlugin';
import { ViewVocabFlowReadOnlyPlugin } from '../../../shared/components/IELTSample/ViewVocabFlow/plugins/ViewVocabFlowReadOnlyPlugin';
import { ViewIdeaFlowReadOnlyPlugin } from '../../../shared/components/IELTSample/ViewIdeaFlow/plugins/ViewIdeaFlowReadOnlyPlugin';
import { AbbrReadOnlyPlugin } from '../../../slatePlugins/marks/abbr/AbbrReadOnlyPlugin';
import { CiteReadOnlyPlugin } from '../../../slatePlugins/marks/cite/CiteReadOnlyPlugin';
import { QReadOnlyPlugin } from '../../../slatePlugins/marks/q/QReadOnlyPlugin';

export const getAllTextFormatReadOnlyPlugins = ({ options, isReadOnly }) => [
  // text format (leaf)
  AlignReadOnlyPlugin(),
  BoldReadOnlyPlugin(options),
  ItalicReadOnlyPlugin(options),

  HighlightElementReadOnlyPlugin({
    colors: DEFAULT_HIGHLIGHT_COLORS_LIST,
  }),
  StrikethroughReadOnlyPlugin(options),
  TextTransformPlugin(), // uppercase, titlecase, lowercase
  QuestionStyleReadOnlyPlugin(), // a rounded circle text to indicate question number
  RoundedElementReadOnlyPlugin(), // rounded text with annotation
  TextColorReadOnlyPlugin(),
  UnderlineReadOnlyPlugin(options),
  UnderlineColorReadOnlyPlugin(),
  HyperLinkElementReadOnlyPlugin({ isReadOnly }),
  ViewVocabFlowReadOnlyPlugin({ isReadOnly }),
  ViewIdeaFlowReadOnlyPlugin({ isReadOnly }),

  IconReadOnlyPlugin(), // emoji - old, least used
  AbbrReadOnlyPlugin(),
  CiteReadOnlyPlugin(),
  QReadOnlyPlugin(),
];
